export default __webpack_public_path__ + "static/allProjects6-c3712c4a14d9670bc0d5eb01daacf87e.png";